import React, { useState } from "react";
import IAccounting from "../../../../models/IAccounting";
import OwLabel from "../../../shared/OwLabel/OwLabel";

type Props = {
    row: IAccounting;
};

export const AccountingOrdersCol = (props: Props) => {
    const [showOrders, setShowOrders] = useState(false);

    const orders = props.row.totalOrders || 0;

    const ordersLinks = props.row.Orders?.map((order, index) => {
        return (
            <div key={order.guid} className={"text-end"}>
                {index + 1} -{" "}
                <a href={`/orders/${order.guid}/entry`} key={order.guid}>
                    {order.name}
                </a>
            </div>
        );
    });

    return (
        <div>
            {orders}
            <OwLabel
                className={"ms-5"}
                leftIconClass={showOrders ? "fa fa-eye-slash" : "fa fa-eye"}
                title={showOrders ? "hide" : "show"}
                fn={() => {
                    setShowOrders(!showOrders);
                }}
            />{" "}
            {showOrders ? ordersLinks : null}
        </div>
    );
};
